module.exports = __webpack_public_path__ + "img/rightTop2.0a8f2e33.png";